// extracted by mini-css-extract-plugin
export var benchmarks = "pills-module--benchmarks--e74b3";
export var customerHub = "pills-module--customerHub--388aa";
export var emailMarketing = "pills-module--emailMarketing--c7878";
export var fadeOut = "pills-module--fadeOut--76c5b";
export var floating1 = "pills-module--floating1--8205a";
export var floating2 = "pills-module--floating2--18e7f";
export var integrations = "pills-module--integrations--09c68";
export var klaviyoAi = "pills-module--klaviyoAi--ab6ca";
export var mobilePush = "pills-module--mobilePush--98c46";
export var pill = "pills-module--pill--7b1a8";
export var pillContainer = "pills-module--pillContainer--bbedc";
export var profiles = "pills-module--profiles--7c2cf";
export var removePill = "pills-module--removePill--a2c8e";
export var removePills = "pills-module--removePills--27192";
export var reporting = "pills-module--reporting--b42dd";
export var reviews = "pills-module--reviews--7eb56";
export var segments = "pills-module--segments--d93e4";
export var smsMarketing = "pills-module--smsMarketing--592c7";